import script from "./JobDetailsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetailsComponent.vue?vue&type=script&setup=true&lang=js"

import "./JobDetailsComponent.vue?vue&type=style&index=0&id=75c0ac25&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c0ac25"]])

export default __exports__